import { canReadText, canReadTextV2, hexToRGB } from 'MeetingsBase/utils/color';
function expandHexShorthand(hex) {
  if (hex.length === 4 && hex.startsWith('#')) {
    // Convert #abc to #aabbcc
    return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
  }
  return hex;
}
export function getColorStyleWithOpacity(primaryColor, opacity = 0.05) {
  const rgb = hexToRGB(primaryColor);
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
}
export function shadeColor(color, percent) {
  /**
   * Source code from: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
   * @param {string} color - A hex color string (must start with #)
   * @param {int} percent - Percentage by which to lighten the color, can be negative
   * to darken color
   * @returns {string} color - A color, lightened by the given percentage
   */
  const num = parseInt(color.slice(1), 16);
  let red = Math.floor(num / 0x10000) + percent;
  if (red > 255) red = 255;else if (red < 0) red = 0;
  let blue = Math.floor(num / 0x100) % 0x100 + percent;
  if (blue > 255) blue = 255;else if (blue < 0) blue = 0;
  let green = num % 0x100 + percent;
  if (green > 255) green = 255;else if (green < 0) green = 0;
  return `#${(green + blue * 0x100 + red * 0x10000).toString(16).padStart(6, '0')}`;
}
export function getPrimaryButtonStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      backgroundColor: null,
      borderColor: null,
      color: null
    };
  }
  return {
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    color: canReadText(primaryColor, theme.color['text-primary-default']) ? theme.color['text-primary-default'] : theme.color['text-core-default']
  };
}
export function getPrimaryButtonHoverStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      backgroundColor: null,
      borderColor: null,
      color: null
    };
  }
  return {
    backgroundColor: shadeColor(primaryColor, 20),
    borderColor: shadeColor(primaryColor, 20),
    color: canReadText(primaryColor, theme.color['text-primary-default']) ? theme.color['text-primary-default'] : theme.color['text-core-default']
  };
}
export function getSecondaryButtonStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      borderColor: null,
      color: null
    };
  }
  return {
    borderColor: primaryColor,
    color: canReadTextV2(theme.color['fill-surface-default'], primaryColor) ? primaryColor : theme.color['text-core-default']
  };
}
export function getSecondaryButtonHoverStyle(primaryColor, theme) {
  if (shouldUseDefaultStyles(primaryColor)) {
    return {
      backgroundColor: null,
      borderColor: null,
      color: null
    };
  }
  return {
    backgroundColor: getColorStyleWithOpacity(primaryColor),
    borderColor: primaryColor,
    color: canReadTextV2(theme.color['fill-surface-default'], primaryColor) ? primaryColor : theme.color['text-core-default']
  };
}
export function shouldUseDefaultStyles(primaryColor) {
  // Match pure white and near-white colors (luminance > 0.95)
  const expandedColor = expandHexShorthand(primaryColor);
  const r = parseInt(expandedColor.slice(1, 3), 16) / 255;
  const g = parseInt(expandedColor.slice(3, 5), 16) / 255;
  const b = parseInt(expandedColor.slice(5, 7), 16) / 255;
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.95;
}